import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const DeleteTestCaseConfirmationModal = ({ testCase, deleteOpen, setDeleteOpen }) => {
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const handleCloseDeleteDialog = () => {
    setDeleteOpen(false)
  }

  const handleDeleteTestCases = async () => {
    setLoading(true)
    try {
      await PageService.deleteTestCases([testCase.id])
      setDeleteOpen(false)
      if (testCase?.journey?.id) {
        navigate(`/test-journey/${testCase.journey.id}`, {
          state: { activeTab: 'testCases' },
        })
      } else {
        navigate(`/pages/${testCase.pageId}`, { state: { activeTab: '3' } })
      }
    } catch (error) {
      console.log(error.message)
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={deleteOpen}
      onClose={handleCloseDeleteDialog}
    >
      <Box className="deleteTestCasesModal">
        <DialogTitle className="deleteTestCasesModalTitle">
          Confirm Delete Test Case
        </DialogTitle>
        <DialogContent className="deleteTestCasesModalContent">
          <DialogContentText className="deleteTestCasesModalContentText">
            Are you sure you want to delete this test case? This will permanently remove it from the system, and it cannot be restored.
          </DialogContentText>
        </DialogContent>
        <DialogActions className="deleteTestCasesModalActions">
          <Button className="deleteTestCasesModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deleteTestCasesModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deleteTestCasesModalButton" onClick={handleDeleteTestCases} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeleteTestCaseConfirmationModal